import { render, staticRenderFns } from "./InsuranceList.vue?vue&type=template&id=9521bb16&scoped=true"
import script from "./InsuranceList.vue?vue&type=script&lang=js"
export * from "./InsuranceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9521bb16",
  null
  
)

export default component.exports